import { render, staticRenderFns } from "./UserPointsLog.vue?vue&type=template&id=7bee8dea&scoped=true&"
import script from "./UserPointsLog.vue?vue&type=script&lang=js&"
export * from "./UserPointsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bee8dea",
  null
  
)

export default component.exports